import { composeClassNames, ifDefined } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import { Image, Jumbotron } from "react-bootstrap";
import Content from "src/components/Content";
import MqGteTablet from "src/components/MqGteTablet";
import MqPhone from "src/components/MqPhone";
import constants from "src/constants";
import styleImage from "src/functions/styleImage";
import styleImageWrapper from "src/functions/styleImageWrapper";
import { sInstructorImg } from "src/styles/sInstructorImg.module.scss";
import { sProfileHead } from "src/styles/sProfileHead.module.scss";
import { sProfileMotive } from "src/styles/sProfileMotive.module.scss";
import { ApiMotive } from "src/types/ApiMotive";
import { ApiThumbnail } from "src/types/ApiThumbnail";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  motiveImg: ApiMotive;
  profileImg: ApiThumbnail;
};

function ProfileHead({ style, className, motiveImg, profileImg }: Props) {
  var motiveImgUrlLarge = motiveImg
    ? motiveImg.image
      ? !constants.Images.motivePhotoFullSize
        ? ifDefined(
            motiveImg.image.formats,
            (value) =>
              motiveImg.image.formats.large
                ? motiveImg.image.formats.large.url
                : motiveImg.image.url,
            () => motiveImg.image.url
          )
        : motiveImg.image.url
      : null
    : null;
  var motiveImgUrlMedium = motiveImg
    ? motiveImg.image
      ? ifDefined(
          motiveImg.image.formats,
          (value) =>
            motiveImg.image.formats.medium
              ? motiveImg.image.formats.medium.url
              : motiveImg.image.url,
          () => motiveImg.image.url
        )
      : null
    : null;
  var motiveImgUrlSmall = motiveImg
    ? motiveImg.image
      ? ifDefined(
          motiveImg.image.formats,
          (value) =>
            motiveImg.image.formats.small
              ? motiveImg.image.formats.small.url
              : motiveImg.image.url,
          () => motiveImg.image.url
        )
      : null
    : null;
  var profileImgUrlLarge = profileImg
    ? ifDefined(
        profileImg.formats,
        (value) =>
          !constants.Images.profilePhotoFullSize
            ? profileImg.formats.large
              ? profileImg.formats.large.url
              : profileImg.url
            : profileImg.url,
        () => profileImg.url
      )
    : null;
  var profileImgUrlMedium = profileImg
    ? ifDefined(
        profileImg.formats,
        (value) =>
          profileImg.formats.medium
            ? profileImg.formats.medium.url
            : profileImg.url,
        () => profileImg.url
      )
    : null;
  var profileImgUrlSmall = profileImg
    ? ifDefined(
        profileImg.formats,
        (value) =>
          profileImg.formats.small
            ? profileImg.formats.small.url
            : profileImg.url,
        () => profileImg.url
      )
    : null;
  return (
    <Jumbotron
      className={composeClassNames([sProfileHead, className, "profile-images"])}
      style={style}
    >
      {motiveImg ? (
        motiveImg.image ? (
          <>
            <MqGteTablet>
              <div
                className={composeClassNames([
                  sProfileMotive,
                  "profile-motive",
                ])}
                style={styleImageWrapper(
                  motiveImg.align,
                  motiveImg.background_color,
                  motiveImg.background_pattern
                )}
              >
                <Image
                  fluid={true}
                  className={`profile-motive-photo`}
                  src={constants.Paths.imagesUrl + motiveImgUrlLarge}
                  alt={motiveImg.image.alternativeText}
                  style={styleImage(
                    motiveImg.width,
                    motiveImg.height,
                    motiveImg.object_fit
                  )}
                />
              </div>
            </MqGteTablet>
            <MqPhone>
              <div
                className={composeClassNames([
                  sProfileMotive,
                  "profile-motive",
                ])}
                style={styleImageWrapper(
                  motiveImg.align,
                  motiveImg.background_color,
                  motiveImg.background_pattern
                )}
              >
                {motiveImg.apply_mobile ? (
                  <Image
                    fluid={true}
                    className={`profile-motive-photo`}
                    src={constants.Paths.imagesUrl + motiveImgUrlMedium}
                    alt={motiveImg.image.alternativeText}
                    style={styleImage(
                      motiveImg.width,
                      motiveImg.height,
                      motiveImg.object_fit
                    )}
                  />
                ) : (
                  <Image
                    fluid={true}
                    className={`profile-motive-photo`}
                    src={constants.Paths.imagesUrl + motiveImgUrlMedium}
                    alt={motiveImg.image.alternativeText}
                    style={styleImage(`fill`, `fill`, `cover`)}
                  />
                )}
              </div>
            </MqPhone>
          </>
        ) : null
      ) : null}
      {profileImg ? (
        <>
          <MqGteTablet>
            <Content fluid={`xl`}>
              <Image
                roundedCircle={true}
                className={composeClassNames([
                  sInstructorImg,
                  "bordered",
                  "shadow",
                  "profile-photo",
                ])}
                src={constants.Paths.imagesUrl + profileImgUrlLarge}
                alt={profileImg.alternativeText}
              />
            </Content>
          </MqGteTablet>
          <MqPhone>
            <Image
              roundedCircle={true}
              className={composeClassNames([
                sInstructorImg,
                "bordered",
                "shadow",
                "profile-photo",
              ])}
              src={constants.Paths.imagesUrl + profileImgUrlMedium}
              alt={profileImg.alternativeText}
            />
          </MqPhone>
        </>
      ) : null}
    </Jumbotron>
  );
}

export default ProfileHead;
